module.exports = require("npm:ono@2.2.1/lib/index.js");